/**
 * Check if the screen is mobile, based on the width of the screen or touch support
 *
 * Note: This is not a perfect solution, but it's good enough for our purposes
 * @returns {boolean} true if the screen is mobile
 */
export const isMobile = (): boolean => {
  return window.matchMedia('(any-pointer:coarse)').matches || window.innerWidth < 768
}
